import React, { Component } from "react";
import { connect } from "react-redux";

class CartOptions extends Component {
  render() {
    const language = this.props.language;
    const options = [];
    for (var group in this.props.product.options) {
      let OptionGroup = this.props.originalProduct.options.find(
        (optionGroup) => optionGroup.id === parseInt(group)
      );
      let choice = undefined;
      options.push(
        <p
          key={`Drawer OptionGroup ${OptionGroup.name} ${group}`}
          className="text-muted m-0 px-2"
          style={{ fontSize: this.props.cart ? "0.8rem" : "0.95rem" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {Object.keys(this.props.product.options[group].selectedOptions).map(
            (key, indx) => {
              choice = OptionGroup.choices.find((option) => option.id == key);
              return (
                <p
                  className="mb-2"
                  key={`CartProductOption ${choice.value} ${choice.id}`}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 10px",
                    alignItems: "top",
                  }}
                >
                  <span>
                    {language == "english" ? choice.value : choice.ar_value}{" "}
                  </span>{" "}
                  <span
                    style={{
                      display: "flex",
                    }}
                  >
                    <span>x</span>
                    <span
                      className={(language === "arabic" && "mr-1") || "ml-1"}
                    >
                      {
                        this.props.product.options[group].selectedOptions[key]
                          .quantity
                      }
                    </span>
                  </span>
                </p>
              );
            }
          )}
        </p>
      );
    }
    return (
      <div
        className="ml-2"
        style={{
          textAlign: this.props.centerItems
            ? "center"
            : language === "arabic"
            ? "right"
            : "left",
          marginTop: this.props.checkout && 7,
        }}
      >
        {options}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(CartOptions);
